module.exports = __webpack_public_path__ + "img/3.16f3eee5.png";